var _defs, _path, _path2, _path3, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRageful(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_30",
    "data-name": "Group 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 433.742,
    height: 87.745,
    viewBox: "0 0 433.742 87.745",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_41",
    "data-name": "Rectangle 41",
    width: 433.742,
    height: 87.745,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M0,8.707l7.757,3.971L26.37,22.171,7.757,31.664,0,35.635v8.687l7.757-3.971,35.677-18.18L7.757,3.991,0,.02Z",
    transform: "translate(0 -0.015)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M287.977,0l-7.757,3.971-35.677,18.18,35.677,18.18,7.757,3.971V35.615l-7.757-3.971-18.613-9.493,18.613-9.493,7.757-3.971Z",
    transform: "translate(-188.635 0)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M123.816,229.494l-3.971,7.757h8.687l3.971-7.757L142,210.881l9.493,18.613,3.971,7.757h8.687l-3.971-7.757L142,193.817Z",
    transform: "translate(-92.446 -149.506)",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M618.881,161.274l2.211,4.318h-4.836l-2.211-4.318-2.314-4.525-.1-.207a4.28,4.28,0,0,0-3.662-2.073h-4.318v11.124h-4.318V141.411H614.6a6.473,6.473,0,0,1,4.594,1.9,6.614,6.614,0,0,1,1.9,4.629,6.548,6.548,0,0,1-3.8,5.941,5.758,5.758,0,0,1-1.866.519ZM614.6,150.151a2.018,2.018,0,0,0,.9-.207,2.194,2.194,0,0,0,1.313-2,2.283,2.283,0,0,0-.656-1.59,2.179,2.179,0,0,0-1.555-.621H603.647v4.455Z",
    transform: "translate(-462.309 -109.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M728.578,165.44h-4.837l-2.211-4.318-5.285-10.363-5.285,10.363-2.211,4.318h-4.837l2.211-4.318,10.121-19.863,10.122,19.863Z",
    transform: "translate(-542.982 -108.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M810.24,153.349a7.784,7.784,0,0,0,7.773,7.772h7.772v-4.628h-7.772v-4.318H830.1v13.265h-12.09a12.091,12.091,0,0,1,0-24.181H830.1v4.318h-12.09a7.784,7.784,0,0,0-7.773,7.773",
    transform: "translate(-621.67 -108.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M931.257,147.788v2.246H946.8v4.318H931.257v4.56a2.226,2.226,0,0,0,2.211,2.211H951.12v4.318H933.467a6.517,6.517,0,0,1-6.494-6.529V147.788a6.517,6.517,0,0,1,6.494-6.529H951.12v4.318H933.467a2.226,2.226,0,0,0-2.211,2.211",
    transform: "translate(-715.046 -108.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1072.057,141.258v4.318h-17.652a2.226,2.226,0,0,0-2.211,2.211v2.246h15.545v4.318h-15.58v11.089h-4.284V147.787a6.517,6.517,0,0,1,6.495-6.529Z",
    transform: "translate(-808.307 -108.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M1192.811,141.258v12.091a12.09,12.09,0,0,1-24.18,0V141.258h4.318v12.091a7.773,7.773,0,0,0,15.545,0V141.258Z",
    transform: "translate(-901.454 -108.963)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M1309.464,161.274v4.319H1297.2a7.515,7.515,0,0,1-3.386-.8,7.661,7.661,0,0,1-3.489-3.524,7.508,7.508,0,0,1-.794-3.385V141.411h4.318V158.3a3.444,3.444,0,0,0,2.936,2.936Z",
    transform: "translate(-994.716 -109.081)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M1484.215,165.44h-4.836l-2.211-4.318-5.285-10.363-5.285,10.363-2.211,4.318h-4.836l2.211-4.318,10.121-19.863L1482,161.121Z",
    transform: "translate(-1125.864 -108.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M1596.532,143.229a6.474,6.474,0,0,1,1.9,4.594,6.548,6.548,0,0,1-3.8,5.941,5.764,5.764,0,0,1-1.865.519h-.207v.034h-11.572V165.44h-4.319V141.259H1591.9a6.475,6.475,0,0,1,4.594,1.9Zm-3.7,6.6a2.2,2.2,0,0,0,1.313-2,2.279,2.279,0,0,0-.657-1.59,2.177,2.177,0,0,0-1.554-.621h-10.951v4.455h10.951a2.019,2.019,0,0,0,.9-.206Z",
    transform: "translate(-1216.205 -108.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1706.857,143.229a6.474,6.474,0,0,1,1.9,4.594,6.548,6.548,0,0,1-3.8,5.941,5.771,5.771,0,0,1-1.866.519h-.207v.034h-11.572V165.44h-4.319V141.259h15.235a6.474,6.474,0,0,1,4.594,1.9Zm-3.7,6.6a2.2,2.2,0,0,0,1.313-2,2.279,2.279,0,0,0-.657-1.59,2.177,2.177,0,0,0-1.554-.621h-10.951v4.455h10.951a2.021,2.021,0,0,0,.9-.206Z",
    transform: "translate(-1301.307 -108.964)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1815.835,147.961v-.138a2.227,2.227,0,0,0-2.211-2.211h-9.811a2.226,2.226,0,0,0-2.211,2.211v.138a2.227,2.227,0,0,0,2.211,2.211h8.705a7.586,7.586,0,0,1,5.63,2.487c.1.1.173.207.277.312a7.635,7.635,0,0,1-5.907,12.47h-7.565a7.637,7.637,0,0,1-7.635-7.635h4.318a3.317,3.317,0,0,0,3.316,3.316h7.565a3.316,3.316,0,1,0,0-6.633h-8.705a6.456,6.456,0,0,1-4.525-1.831,6.028,6.028,0,0,1-.829-1.036,6.418,6.418,0,0,1-1.14-3.7v-.138a6.517,6.517,0,0,1,6.494-6.529h9.811a6.546,6.546,0,0,1,6.528,6.529v.138Z",
    transform: "translate(-1386.411 -108.964)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRageful);
export default __webpack_public_path__ + "static/media/rageful.23cb7a37ebba7e3a17694b1bc6428521.svg";
export { ForwardRef as ReactComponent };